import HmsTableWithFilters from 'components/HmsTableWithFilters';
import useEntities from 'hooks/useEntities';
import { entityColumnsToAntColumns } from 'utils/entityColumnsToAntColumns';

const SeasonSpecialRequests = ({ sourceEntityId: id, data }) => {
    const entities = useEntities();
    const childEntity = entities.SeasonSpecialRequest;

    console.log('SeasonSpecialRequests', data);

    return (
        <HmsTableWithFilters
            exportEnabled={true}
            layoutType='plain'
            createButtonLink={`/seasonspecialrequests/_new_?parentId=${id}`}
            onRowClickedLink={(record) => childEntity.entityUrl(record)}
            columns={entityColumnsToAntColumns(childEntity, [
                'name',
                'label',
                'description',
                'placeholder',
                'icon',
            ])}
            data={data}
        />
    )
}

export default SeasonSpecialRequests
